import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconLinkedinStyle0 = gravityIconIndividualCss;

const GravityIconLinkedin = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'b5d2318d3cf28c82a8c65467cd7e9d214d4a362d', color: this.color, size: this.size }, h("svg", { key: '30fbd9c34765f4543237d9521aa551ae2e94c001', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'b71f84db405b13f327213def2e906ee8043d78f7', d: "M7.113 5.563c0 .863-.694 1.562-1.55 1.562-.857 0-1.55-.7-1.55-1.562C4.013 4.7 4.706 4 5.563 4c.856 0 1.55.7 1.55 1.563Zm.012 2.812H4v10h3.125v-10Zm4.989 0H9.009v10h3.105v-5.25c0-2.918 3.768-3.157 3.768 0v5.25H19v-6.332c0-4.925-5.576-4.745-6.886-2.321V8.375Z", fill: "currentColor" }))));
    }
};
GravityIconLinkedin.style = GravityIconLinkedinStyle0;

export { GravityIconLinkedin as gravity_icon_linkedin };

//# sourceMappingURL=gravity-icon-linkedin.entry.js.map